import { render, staticRenderFns } from "./Metric.vue?vue&type=template&id=075bd03e&"
import script from "./Metric.vue?vue&type=script&lang=js&"
export * from "./Metric.vue?vue&type=script&lang=js&"
import style0 from "./Metric.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports